import { useMutation, useQueryClient } from '@tanstack/react-query'
import apiClientPlatform from '@/apiClientPlatform'
import type {
  PlatformUnsuspendOwnerBody,
  PlatformUnsuspendOwnerResponse,
} from '@/types/platform'

export const useSuspendOwnerMutation = (ownerId: string) => {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async (payload: PlatformUnsuspendOwnerBody) => {
      const { data } =
        await apiClientPlatform.patch<PlatformUnsuspendOwnerResponse>(
          `/platform/owners/${ownerId}/suspend`,
          payload
        )
      return data
    },
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['platformOwners'] })
      await qc.invalidateQueries({
        queryKey: ['platformOwnerOverview', ownerId],
      })
      await qc.invalidateQueries({ queryKey: ['platformOwner', ownerId] })
      await qc.invalidateQueries({ queryKey: ['platformAudit'] })
    },
  })
}
